import { InjectionToken } from "@angular/core";

export interface IPermissionKeys {
	add_discount: string;
	add_discount_payment: string;
	add_discount_special: string;
	admin_void_ticket: string;
	authorize_tickets: string;
	change_payment_type: string;
	change_price: string;
	change_quantity: string;
	change_table: string;
	change_tax: string;
	change_user_settings: string;
	create_new_ticket: string;
	drawer_assignment: string;
	drawer_pull: string;
	edit_ticket: string;
	group_settle: string;
	manage_table_layout: string;
	no_service_fee: string;
	only_increase_price: string;
	pay_bill: string;
	pay_out: string;
	perform_administrative_task: string;
	perform_manager_task: string;
	print_bill: string;
	refund: string;
	reopen_ticket: string;
	settle_ticket: string;
	shut_down: string;
	split_ticket: string;
	take_out: string;
	view_all_open_ticket: string;
	view_back_office: string;
	view_explorers: string;
	view_reports: string;
	void_ticket: string;
	member_history: string;
	member_management: string;
	edit_invoice: string;
	publish_invoice: string;
	switch_filter: string;
	account_management: string;
	move_to_waiting: string;
	move_to_cash: string;
	kitchen_view: string;
}

export const PermissionKeys: IPermissionKeys = {
	add_discount: "add_discount",
	add_discount_payment: "add_discount_payment",
	add_discount_special: "add_discount_special",
	admin_void_ticket: "admin_void_ticket",
	authorize_tickets: "authorize_tickets",
	change_payment_type: "change_payment_type",
	change_price: "change_price",
	change_quantity: "change_quantity",
	change_table: "change_table",
	change_tax: "change_tax",
	change_user_settings: "change_user_settings",
	create_new_ticket: "create_new_ticket",
	drawer_assignment: "drawer_assignment",
	drawer_pull: "drawer_pull",
	edit_ticket: "edit_ticket",
	group_settle: "group_settle",
	manage_table_layout: "manage_table_layout",
	no_service_fee: "no_service_fee",
	only_increase_price: "only_increase_price",
	pay_bill: "pay_bill",
	pay_out: "pay_out",
	perform_administrative_task: "perform_administrative_task",
	perform_manager_task: "perform_manager_task",
	print_bill: "print_bill",
	refund: "refund",
	reopen_ticket: "reopen_ticket",
	settle_ticket: "settle_ticket",
	shut_down: "shut_down",
	split_ticket: "split_ticket",
	take_out: "take_out",
	view_all_open_ticket: "view_all_open_ticket",
	view_back_office: "view_back_office",
	view_explorers: "view_explorers",
	view_reports: "view_reports",
	void_ticket: "void_ticket",
	member_history: "member_history",
	member_management: "member_management",
	edit_invoice: "edit_invoice",
	publish_invoice: "publish_invoice",
	switch_filter: "switch_filter",
	account_management: "account_management",
	move_to_waiting: "move_to_waiting",
	move_to_cash: "move_to_cash",
	kitchen_view: "kitchen_view"

};

export const PERM_KEYS = new InjectionToken<IPermissionKeys>(
	"permissions.constant.ts"
);
